import React from "react";
import "./../../App.css"; // Import global styles if needed

export const Contact = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1 style={{ fontSize: "2.5rem", marginBottom: "20px", color: "#004d66" }}>
        Kontakta oss
      </h1>
      <div
        style={{
          display: "inline-block",
          textAlign: "left",
          backgroundColor: "#e6f7ff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
        }}
      >
        <p style={{ fontSize: "1.2rem", margin: "10px 0", color: "#004d66" }}>
          <strong>Kontaktperson:</strong> Marcus Linnér
        </p>
        <p style={{ fontSize: "1.2rem", margin: "10px 0", color: "#004d66" }}>
          <strong>Tel:</strong> 072-530 06 93
        </p>
        <p style={{ fontSize: "1.2rem", margin: "10px 0", color: "#004d66" }}>
          <strong>Mail:</strong>{" "}
          <a
            href="mailto:marcussvets95@gmail.com"
            style={{ color: "#007399", textDecoration: "none" }}
          >
            marcussvets95@gmail.com
          </a>
        </p>
        <p style={{ fontSize: "1.2rem", margin: "10px 0", color: "#004d66" }}>
          <strong>Adress:</strong> Lundby 124 Byggnad C2, 47296 Varekil
        </p>
        <p style={{ fontSize: "1.2rem", margin: "10px 0", color: "#004d66" }}>
          <a
            href="https://maps.app.goo.gl/pRwxrHmUmCz3goELA"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007399", textDecoration: "none" }}
          >
            länk till google maps
          </a>
        </p>
      </div>
    </div>
  );
};
